"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TransmuteCollection = require("./TransmuteCollection");

_TransmuteCollection.every.implement(Array, function (predicate, arr) {
  return arr.every(predicate);
});

_TransmuteCollection.every.implementInherited(_immutable.Iterable, function (test, iter) {
  return iter.every(test);
});

_TransmuteCollection.every.implement(Object, function (predicate, obj) {
  var keys = Object.keys(obj);
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    var key = keys[i];

    if (!predicate(obj[key], key, obj)) {
      return false;
    }
  }

  return true;
});

var _default = _TransmuteCollection.every;
exports.default = _default;
module.exports = exports.default;